import { render, staticRenderFns } from "./AddExamProcess.vue?vue&type=template&id=2dc2b088&scoped=true"
import script from "./AddExamProcess.vue?vue&type=script&lang=js"
export * from "./AddExamProcess.vue?vue&type=script&lang=js"
import style0 from "./AddExamProcess.vue?vue&type=style&index=0&id=2dc2b088&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc2b088",
  null
  
)

export default component.exports